import {
  PENJUALAN_ALL_CABANG_GET_FAIL,
  PENJUALAN_ALL_CABANG_GET_REQUEST,
  PENJUALAN_ALL_CABANG_GET_RESET,
  PENJUALAN_ALL_CABANG_GET_SUCCESS,
} from "../constants/PenjualanAllCabangConstants";

export const penjualanModul_get_all_cabang_reducers = (
  state = { data: {} },
  action
) => {
  switch (action.type) {
    case PENJUALAN_ALL_CABANG_GET_REQUEST:
      return { loading: true };
    case PENJUALAN_ALL_CABANG_GET_SUCCESS:
      return { loading: false, data: action.payload, success: true };
    case PENJUALAN_ALL_CABANG_GET_FAIL:
      return { loading: false, error: action.payload };
    case PENJUALAN_ALL_CABANG_GET_RESET:
      return {};
    default:
      return state;
  }
};
